function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapaCads3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-170"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.29,123.05q-4.41-2.52-8.76-5.14C392.31,99,246.43,13.5,188.3,26.29,123,40.65-1.89,266.86,38.19,328.55s226,160.76,272,139.68,159-225.88,163.67-274.55C477.86,152.12,442.67,128.94,432.29,123.05Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.29,123.05q-4.41-2.52-8.76-5.14C392.31,99,246.43,13.5,188.3,26.29,123,40.65-1.89,266.86,38.19,328.55s226,160.76,272,139.68,159-225.88,163.67-274.55C477.86,152.12,442.67,128.94,432.29,123.05Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-170"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.64,
    cy: 440.45,
    rx: 165.45,
    ry: 30.33,
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-170"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 91.7,
    y1: 262.31,
    x2: 234.47,
    y2: 245.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "5,5"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.73,
    y1: 199.22,
    x2: 238.69,
    y2: 232.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "5,5"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.55,
    y1: 146.19,
    x2: 232.65,
    y2: 216,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "5,5"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.31,
    y1: 141.5,
    x2: 246.07,
    y2: 213.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "5,5"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.77,
    y1: 93.17,
    x2: 250.77,
    y2: 211.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "5,5"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 353.45,
    y1: 89.15,
    x2: 265.53,
    y2: 214.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "5,5"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.44,
    y1: 135.46,
    x2: 270.23,
    y2: 223.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "5,5"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.08,
    y1: 203.91,
    x2: 272.91,
    y2: 234.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "5,5"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 394.4,
    y1: 286.47,
    x2: 278.28,
    y2: 249.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "5,5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calculator--inject-170"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 399.44,
    y: 269.29,
    width: 40.2,
    height: 36.42,
    rx: 8.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.71,
    y: 278.6,
    width: 11.94,
    height: 2.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.71,
    y: 291.94,
    width: 11.94,
    height: 2.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.65 273.78 409.34 273.78 409.34 278.6 404.53 278.6 404.53 280.91 409.34 280.91 409.34 285.73 411.65 285.73 411.65 280.91 416.47 280.91 416.47 278.6 411.65 278.6 411.65 273.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.9 289.17 410.5 292.58 407.09 289.17 405.46 290.81 408.86 294.21 405.46 297.62 407.09 299.25 410.5 295.85 413.9 299.25 415.54 297.62 412.13 294.21 415.54 290.81 413.9 289.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.01,
    cy: 289.48,
    r: 1.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.01,
    cy: 297.04,
    r: 1.56,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Alarm--inject-170"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 425.92,
    cy: 198.75,
    r: 21.71,
    transform: "translate(-25.77 68.79) rotate(-8.96)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.92,222.33a23.58,23.58,0,1,1,23.58-23.58A23.6,23.6,0,0,1,425.92,222.33Zm0-43.42a19.85,19.85,0,1,0,19.84,19.84A19.87,19.87,0,0,0,425.92,178.91Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.88,206.31c-1.69,0-2.49-.6-2.85-1.34V194.72a8.24,8.24,0,0,0-5.27-7.68,2.44,2.44,0,0,0,.06-.55,2.59,2.59,0,0,0-2.6-2.6h-.67a2.6,2.6,0,0,0-2.61,2.6,2.54,2.54,0,0,0,.05.49,8.24,8.24,0,0,0-5.42,7.74V205c-.36.74-1.17,1.34-2.86,1.34v2.86h8.41c0,.06,0,.11,0,.17a2.69,2.69,0,1,0,5.38,0c0-.06,0-.11,0-.17h8.4Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Locator--inject-170"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.87,109.33a13.8,13.8,0,0,0-13.8,13.81c0,7.62,13.8,20.6,13.8,20.6s13.81-13,13.81-20.6A13.81,13.81,0,0,0,417.87,109.33Zm0,18.66a4.86,4.86,0,1,1,4.86-4.85A4.85,4.85,0,0,1,417.87,128Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Camera--inject-170"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.72,
    y: 53.87,
    width: 40.49,
    height: 26.69,
    rx: 3.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.96,
    cy: 67.22,
    r: 7.96,
    transform: "translate(58.19 274.93) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.37,
    cy: 59.76,
    r: 2.72,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-170"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.87,70.2a5,5,0,0,1,5-5h5.06V50.85a5.19,5.19,0,0,0-5.2-5.19H223.17a5.19,5.19,0,0,0-5.2,5.19v16a5.2,5.2,0,0,0,5.2,5.2h6.17l5.41,11.18,3-11.18h8.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.87,66.66h18.8a3.55,3.55,0,0,1,3.54,3.54V81.1a3.54,3.54,0,0,1-3.54,3.54h-4.21l-3.69,7.63-2-7.63h-8.86a3.54,3.54,0,0,1-3.54-3.54V70.2A3.55,3.55,0,0,1,250.87,66.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.56,
    y1: 52.93,
    x2: 248.34,
    y2: 52.93,
    style: {
      fill: "none",
      stroke: "#C53F3F",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.56,
    y1: 58.52,
    x2: 248.34,
    y2: 58.52,
    style: {
      fill: "none",
      stroke: "#C53F3F",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.56,
    y1: 64.12,
    x2: 248.34,
    y2: 64.12,
    style: {
      fill: "none",
      stroke: "#C53F3F",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-170"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.61,81.86l5.37.77,1.45-6.35-5.06-1.6a13.51,13.51,0,0,0-.94-4.47l3.82-3.6-4.07-5.1-4.28,2.88a13.2,13.2,0,0,0-4.22-2.08l-.42-5.11h-6.52l-.42,5.09a13.23,13.23,0,0,0-4.23,2.07l-4.29-2.88-4.06,5.1,3.8,3.58a13.52,13.52,0,0,0-1,4.47l-5.06,1.6L110,82.59l5.34-.77a13.72,13.72,0,0,0,2.78,3.42l-2,5.11L122,93.18l2.78-4.76a13.19,13.19,0,0,0,2.18.2,13.75,13.75,0,0,0,2.15-.19l2.79,4.77,5.88-2.83-2-5.1A13.46,13.46,0,0,0,138.61,81.86ZM120.82,75.2A6.16,6.16,0,1,1,127,81.35,6.16,6.16,0,0,1,120.82,75.2Z",
    style: {
      fill: "#C53F3F",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.25,59.46l3.65.53,1-4.32-3.44-1.09a9.2,9.2,0,0,0-.64-3l2.59-2.45-2.76-3.46-2.91,2a8.94,8.94,0,0,0-2.87-1.41l-.28-3.47h-4.43l-.28,3.46a9.07,9.07,0,0,0-2.88,1.4l-2.91-2-2.76,3.46,2.58,2.43a9.07,9.07,0,0,0-.65,3l-3.44,1.09,1,4.32,3.63-.52a9.2,9.2,0,0,0,1.89,2.32L145,65.23l4,1.92,1.9-3.23a9,9,0,0,0,1.48.13,9.89,9.89,0,0,0,1.45-.12l1.9,3.24,4-1.93-1.33-3.46A9,9,0,0,0,160.25,59.46Zm-12.08-4.52a4.18,4.18,0,1,1,4.18,4.18A4.18,4.18,0,0,1,148.17,54.94Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Envelope--inject-170"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.88,
    y: 104.98,
    width: 42.42,
    height: 29.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.88 104.98 168.09 119.52 189.3 104.98 146.88 104.98",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-170"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85.76,
    cy: 133.56,
    r: 20.35,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "85.76 144.76 85.76 133.56 76.81 133.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-170"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.38,178.1v1.26a4.06,4.06,0,0,1-8.12,0V178.1H57.4v1.26a4.06,4.06,0,0,1-4.06,4.06h0a4.06,4.06,0,0,1-4.06-4.06V178.1H44v38H79.21v-38Z",
    style: {
      fill: "#C53F3F",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.78,209.16v-2l5.46-8.51c.41-.63.78-1.23,1.13-1.77a9.34,9.34,0,0,0,.85-1.74,6.19,6.19,0,0,0,.33-2.11,4.78,4.78,0,0,0-.48-2.33,1.75,1.75,0,0,0-1.67-.84,2.11,2.11,0,0,0-1.56.55,3,3,0,0,0-.77,1.46,8.46,8.46,0,0,0-.21,1.93v.72H50v-.74a9.47,9.47,0,0,1,.52-3.33,4.27,4.27,0,0,1,1.67-2.16,5.46,5.46,0,0,1,3.06-.77A4.85,4.85,0,0,1,59.14,189a6.06,6.06,0,0,1,1.27,4.07,7.93,7.93,0,0,1-.33,2.41,9.69,9.69,0,0,1-.86,1.94c-.36.6-.75,1.22-1.17,1.85l-4.93,7.53h6.79v2.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8,209.37a5.51,5.51,0,0,1-3.07-.74,4,4,0,0,1-1.63-2.14,10.09,10.09,0,0,1-.49-3.34h2.83A11.39,11.39,0,0,0,65.6,205a3.08,3.08,0,0,0,.68,1.52,2,2,0,0,0,1.57.59,1.94,1.94,0,0,0,1.67-.67,3.74,3.74,0,0,0,.64-1.83,22.75,22.75,0,0,0,.13-2.61,15.94,15.94,0,0,0-.16-2.48,2.81,2.81,0,0,0-.66-1.56,2,2,0,0,0-1.59-.55,2.11,2.11,0,0,0-1.48.55,3.32,3.32,0,0,0-.9,1.23H63.09V187.7h9.24v2.83H65.66l-.19,5.94a3.67,3.67,0,0,1,1.31-.87,4.57,4.57,0,0,1,1.79-.32,4.15,4.15,0,0,1,2.74.82,4.49,4.49,0,0,1,1.41,2.25,12.08,12.08,0,0,1,.41,3.29,18.44,18.44,0,0,1-.24,3.06,7.44,7.44,0,0,1-.84,2.46,4.19,4.19,0,0,1-1.63,1.63A5.24,5.24,0,0,1,67.8,209.37Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Padlock--inject-170"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,265.74v-8.39a14,14,0,0,0-27.9,0v8.39h-.85V294H72.8V265.74Zm-24.23-8.39a10.28,10.28,0,0,1,20.56,0v8.39H47.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,277.24a3.89,3.89,0,1,0-6.15,3.15v6.43h4.53v-6.43A3.86,3.86,0,0,0,62,277.24Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-170"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.46,430c-.59-1.76-27.48-15.41-37.66-20.53h29.06a4.5,4.5,0,1,0,5.31,1.91,2.39,2.39,0,0,0,2.32-.46c1-.72,1.21-4.34-1.44-6-2.31-1.47-38.26-2.21-47.71-2.38V371.29h7.39V338.45H243.14v32.84h7.39v31.24c-12.35.24-42.7,1-44.82,2.32-2.65,1.69-2.41,5.31-1.44,6a2.6,2.6,0,0,0,1.77.59,4.41,4.41,0,0,0-.6,2.19,4.5,4.5,0,1,0,6-4.23H241c-10.19,5.12-37.07,18.77-37.66,20.53a8,8,0,0,0,.21,4.58,6.26,6.26,0,0,0-.21,1.57,6.16,6.16,0,1,0,9.35-5.25c10.61-4.63,43.1-16.15,44.73-16.36,1.6.2,33.05,11.35,44.18,16.12a6.16,6.16,0,1,0,8.93,5.57A8.38,8.38,0,0,0,311.46,430ZM306,409.47l-.13,0h.09Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.44,240.69a21.07,21.07,0,0,1-9.15,5.23c-13.52,3.42-23.09-4.79-29.63,12.64s5.67,52.28,20.92,63.61,39.65,19.17,71,6.54,60.56-47.06,63.61-81.92-80.35-30.25-89-26.23S216.44,240.69,216.44,240.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.47,181.64s-4.82,2.54-6.09,6.09S227.62,219,227.62,219s-1.52-26.15-3.81-41.13S219,145.58,215.43,138s-12.19-13.71-15.74-15-3.81,1-1,2.79,7.11,7.87,7.11,7.87l2.29,4.57s-7.62,9.39-7.62,14.22,9.9,10.41,9.9,10.41-8.38,56.62-6.09,67,8.12,20.82,12.19,21.84,24.12-13.21,24.12-13.21S253,199.67,254,192.3,254.79,180.11,250.47,181.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.47,181.64s-4.82,2.54-6.09,6.09S227.62,219,227.62,219s-.31-5.37-.87-12.63c-8.32,5.84-17,4-22,2.14-.87,9.68-1.26,18-.51,21.41,2.28,10.41,8.12,20.82,12.19,21.84s24.12-13.21,24.12-13.21S253,199.67,254,192.3,254.79,180.11,250.47,181.64Z",
    style: {
      fill: "#C53F3F",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.62,219s.51,7.62.76,12.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.69,141.87s-4.19,3.5-3.85,5.89,7.52,9.22,9.74,8.54,3.24-.86,1-3.84-5.29-6.66-5.8-8S198.69,141.87,198.69,141.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.07,138.22s-6.82.32-8.19,1.6-1.62,4.36,1.2,8.2,4.78,6.31,5.89,5.12.85-2.82-.17-4.53a48.49,48.49,0,0,1-2.31-4.69l3.5-4.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.84,147.76s-2.56,4.27-.76,6.75,7.59,5.8,9.56,4.86.94-3.07.94-3.07a26.71,26.71,0,0,1-4.87-3.08A34.53,34.53,0,0,1,194.84,147.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.21,143s-5.89-5.44-9.14-4.82c-1.46.28-6.86,4.82-7.87,6.86s.5,2.79,2,2.28,7.87-2.79,7.87-2.79-2,8.38,0,10.66,8.38,2.29,8.38,2.29",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.51,177.83s-32.5,1.78-35,3.81-4.32,7.62-4.57,9.14-9.65,46.72-11.43,54.59-18.26,27.43-18.26,27.43,29.64,16.1,43.68,23.27a101,101,0,0,0,29.15,9.4l33-69.75s15.74-38.85,16.25-42.66-.51-2.28-10.66-7.11a80.23,80.23,0,0,0-20.57-6.6C304.55,178.85,285.51,177.83,285.51,177.83Z",
    style: {
      fill: "#C53F3F",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3,339.16l-20.74-.65S61,325.23,58.7,326.2s2.92,16.53,9.72,25.27S94,372.21,97.58,374.15s5.51,3.24,8.74,1,11-17.49,11-17.49Z",
    style: {
      fill: "#C53F3F",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,348.56c-6.25-7.58-10.49-17-12.54-22.14a3.45,3.45,0,0,0-1.72-.22c-2.27,1,2.92,16.53,9.72,25.27S94,372.21,97.58,374.15s5.51,3.24,8.74,1a12,12,0,0,0,2.31-2.58C101.34,368.8,80.4,357.59,73,348.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,409.14s-7.45,13.93-11,19.11-16.85,12-16.52,14.91S163,447,171.77,446.4s16.52-11.34,21-13.93,7.78-3.57,5.19-9.72-5.83-12.31-5.83-12.31Z",
    style: {
      fill: "#C53F3F",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.74,442.51c-6.34,2-18.21-.2-24.79-1.73-1,.94-1.52,1.75-1.45,2.38.32,2.91,16.52,3.88,25.27,3.24s16.52-11.34,21-13.93,7.78-3.57,5.19-9.72C181.49,428.58,181.81,439.59,172.74,442.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.44,307.09l24.62,90.06-3.56,2.92,3.89,13a61.12,61.12,0,0,0,10.36,2.91c7.45,1.62,11.67.65,11.67.65s.32-9.07-.65-12-2.59-8.1-2.59-8.1l-4.54-78.72s41.14,15.55,57.34,14.58-11.66-32.4-30.13-47.62-59-23.65-65.44-7.46A42.92,42.92,0,0,0,148.44,307.09Z",
    style: {
      fill: "#858585",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.85,284.74a63,63,0,0,0-12.8-7.95l-21.59-7.08c-6.72-1.27-13.19-1.59-18.53-.68l14,13.76,11.66,35s41.14,15.55,57.34,14.58S233.32,300,214.85,284.74Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.34,301.91s-5.18,12.95-12.64,22-28.51,11.66-37.25,8.42-32.72-23-46.33-34.67S176,282.79,176,282.79l-47,65.44s-2.59,2.6-2.27,5.19-13,10.69-13,10.69-6.16-5.19-8.1-9.07-3.89-7.13-3.24-9.72-.65-4.54.65-8.1,6.8-5.18,6.8-5.18,41.14-75.81,46-83.26,7.78-9.4,11.34-8.75,51.19,24.62,59,29.16S290.34,301.91,290.34,301.91Z",
    style: {
      fill: "#858585",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.61,312.72a80.2,80.2,0,0,0,6.64,4.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.34,272.86c13,9.79,35.42,27.29,48.71,37.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.78,282.19s1.3-11.28,3-10.84,5.64,5.63,5.64,3-.87-8.67.87-8.67c.35,0,3.13,2,7.39,5.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,167.93s-4.83,21.07-6.86,26.4-7.62,13.46-3.55,14.48,34-24.63,36.05-29.2,5-14.36,5-14.36S294.65,172.5,284,167.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.61,105.89s-8,2.31-4.61,6.74,9.22,4.07,9.22,4.07-4.08-3.72,7.09-3.72,17.71,1.77,17.54,7.8-2.66,9,.17,13.11,6.56,14.53,6.56,14.53l8.68,2s9-10.28,10.81-22.15,3.37-18.07-15.24-28.17-42-11-43.94-4.26A8.88,8.88,0,0,0,285.61,105.89Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.05,106.07s-7.26,5.85-7.44,8.51-8.5,27.1-9.57,34,.89,19,4.26,22.86,11,4.78,19.84,2.48,13.47-5.85,14.53-8.68,8.5-20,8.5-20-5.13-12-6.55-15.42,3.36-9,3.54-10.45-8.5-7.26-11-8.68-5.85-.18-8.33-.89A55.58,55.58,0,0,1,293.05,106.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.67,165.25c1.06-2.84,8.5-20,8.5-20s-1.53-3.61-3.16-7.42c-2.24,5.32-9.27,22-9.42,22.48s-.7-2.31-9.39-6.2-10.1-6.2-15.94-4.61a46.6,46.6,0,0,0-9.39,3.54l-.11.35c.08,6.73,1.86,15,4.54,18.08,3.36,3.9,11,4.78,19.84,2.48S313.61,168.08,314.67,165.25Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.58,148.42s3.72-3.72,7.8-2.13.53,7.44-1.78,9.75S317.33,158,317.33,158Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.73,123.08s2.3-4.07,8,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.49,124.5s5-3,9.75,3.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.41,124.5a25.51,25.51,0,0,1,.88,5.14c0,2-8.86,20-8,20.55s7.09-3.37,7.62-3.37",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.68,131.84c-.4,1.25-1.32,2.08-2.07,1.85s-1-1.45-.63-2.71,1.32-2.09,2.07-1.85S305.08,130.58,304.68,131.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.74,128.29c-.4,1.26-1.33,2.09-2.08,1.85s-1-1.44-.63-2.7,1.33-2.09,2.07-1.86S289.13,127,288.74,128.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.85,135.31s-.18,2.48,4.61,3.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.75,131.05a19.76,19.76,0,0,1-6.2,2.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.66,153.2s5.5,4.25,14.18,1.77",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.36,265.62s-30.78,2.59-39.53,17.17S267,321.67,257.62,329.44s-44.71-1.62-50.54-4.53a105.13,105.13,0,0,0-13-5.19s6.8,10.7,28.51,17.82,54.43,10.37,88.77-2.91,44.06-38.56,48.27-57.67,0-45-6.16-61.23-15.87-26.24-19.11-25.92-2.92,37.26-1,51.19S324.36,265.62,324.36,265.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.3,231.72a25.24,25.24,0,0,0,4.43,4.05c2.5,1.73,3.46,8.08,4.23,9s1.73,4.81,1.73,4.81-6.74-4.81-8.47-6.74S263.3,231.72,263.3,231.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.11,223.71l9.38,33.77a2.06,2.06,0,0,0,1.55,1.46l12.87,2.71a2,2,0,0,0,2.41-2.52l-8.85-34a2,2,0,0,0-1.61-1.5l-13.41-2.45A2,2,0,0,0,245.11,223.71Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.66,186s8.42,3,10.15,4.57,3.08,7.32,6.16,17.33,7.89,51.6,8.09,54.49-12.33,6-22.34,7.7-47.55-1.73-47.55-1.73-7.71-1.16-13.29-1.74-13.86-4.62-15.6-5-.57-3.08-.57-3.08a9.87,9.87,0,0,1-2.89.57c-1.35,0-1.35-1.73-1.35-1.73s1.54-3.66,2.31-4,12.13-.58,12.13-.58l-10-4.43s-5.2,1-6.35.58-.77-2.31,0-2.89,6.73-1.92,7.89-1.54,9.05,2.31,9.05,2.31l-1.16-2.31-9.24-5s-3.66-.2-4.81-.2-3.47-.77-2.89-2.69,6.55-1.74,8.47-1.35,13.48,4.43,15.41,6.55,8.08,14.63,8.08,14.63,11.55,2.31,26-2.31,19.84-6.36,19.84-6.36l-6-29.45",
    style: {
      fill: "#C53F3F",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.35,256.37s-6.16-12.52-8.08-14.63-13.48-6.16-15.41-6.55-7.89-.58-8.47,1.35,1.73,2.69,2.89,2.69,4.81.2,4.81.2l9.24,5,1.16,2.31s-7.89-1.92-9.05-2.31-7.12,1-7.89,1.54-1.16,2.51,0,2.89,6.35-.58,6.35-.58l10,4.43s-11.36.19-12.13.58-2.31,4-2.31,4,0,1.73,1.35,1.73a9.87,9.87,0,0,0,2.89-.57s-1.16,2.69.57,3.08,10,4.43,15.6,5,13.29,1.74,13.29,1.74,14.86,1.37,28.38,1.95c1.87-8.93.91-14.75-.54-18.34l-6.67,2.14C288.9,258.68,277.35,256.37,277.35,256.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.71,258.49a33.65,33.65,0,0,1,3.85-1.16c1.15-.19,8.66,1.73,8.66,1.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapaCads3);
export default __webpack_public_path__ + "static/media/capa-cads3.679249f337174f96670fe7aadbd534c9.svg";
export { ForwardRef as ReactComponent };